import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./Components/Login";
import ProtectedRoute from "./Components/ProtectedRoute";
import { ChatContextProvider } from "./context/chatContext";
import HomePage from "./Pages/HomePage";
import CoursesPage from "./Pages/CoursesPage";
import QuizPage from "./Pages/QuizPage";
import OralAssessment from "./Pages/OralAssessment";
import SubjectSelection from "./Pages/SubjectSelection";
import SelfEvaluation from "./Pages/SelfEvaluation";
import StudentProfilePage from "./Pages/StudentProfilePage";
import StudentDashboard from "./Pages/class-management/dashboard/StudentDashboard";
import StudentLessons from "./Pages/Lessons/StudentLessons";
import StudentAssessments from "./Pages/Assessments/StudentAssessmentsNew";
import AssessmentDetails from "./Pages/Assessments/AssessmentDetails";
import StudentDashboardMarks from "./Pages/MarksEntry/StudentDashboard";
import StudentMarksEntry from "./Pages/Assessments/StudentMarksEntry";

import FoundationalReport from "./Pages/FoundationalReport";
import HPCReportPage from "./Components/HPC_Report/HPCReportPage";
import { AuthBootstrap } from "./authClient";
import CareerMeterComponent from "./Pages/CareerMeterComponent"; // ⬅️ add this
import MyCompetencies from "./Pages/MyCompetencies";
import MyAttendance from "./Pages/MyAttendance";
import StudentCalendar from "./Pages/StudentCalendar";
import DebugPartA3 from "./Components/HPC_Report/DebugPartA3";
import HPCProfile from "./Pages/HPCProfile";
import SecondaryDomainActivities from "./Pages/SecondaryDomainActivities";
import DomainActivityEditor from "./Pages/SecondaryDomainActivities/components/DomainActivityEditor";
import GrowthQuizPage from "./Pages/GrowthQuizPage";
import ReflectionPage from "./Pages/ReflectionPage";
import GrowthReportPage from "./Pages/GrowthReportPage";
import OfficialGrowthAchievement from "./Pages/OfficialGrowthAchievement";
import OfficialAcademicTranscript from "./Pages/OfficialAcademicTranscript";


function App() {
    return (
        <ChatContextProvider>
            <AuthBootstrap> {/* ⬅️ add this wrapper */}

                <Router>
                    <Routes>
                        <Route path="/" element={<Login />} />
                        {/*<Route path="/Signup" element={<Signup/>}/>*/}
                        <Route path="/subjects" element={
                            <ProtectedRoute>
                                <SubjectSelection />
                            </ProtectedRoute>

                        } />
                        <Route path="/class-management" element={
                            <ProtectedRoute>
                                <StudentDashboard />
                            </ProtectedRoute>

                        } />

                        <Route path="/carrier" element={
                            <ProtectedRoute>
                                <CareerMeterComponent />
                            </ProtectedRoute>

                        } />

                        <Route path="/CBSC" element={
                            <ProtectedRoute>
                                <FoundationalReport />
                            </ProtectedRoute>

                        } />

                        <Route path="/Parakh" element={
                            <ProtectedRoute>
                                <HPCReportPage />
                            </ProtectedRoute>

                        } />

                        <Route path="/HomePage" element={
                            <ProtectedRoute>
                                <HomePage />
                            </ProtectedRoute>

                        } />
                        <Route path="/CoursesPage" element={
                            <ProtectedRoute>
                                <CoursesPage />
                            </ProtectedRoute>

                        } />
                        <Route path="/QuizPage" element={
                            <ProtectedRoute>
                                <QuizPage />
                            </ProtectedRoute>
                        } />

                        <Route path="/Oral" element={
                            <ProtectedRoute>
                                <OralAssessment />
                            </ProtectedRoute>
                        } />

                        <Route path="/Eval" element={
                            <ProtectedRoute>
                                <SelfEvaluation />
                            </ProtectedRoute>
                        } />
                        <Route path="/Profile" element={
                            <ProtectedRoute>
                                <StudentProfilePage />
                            </ProtectedRoute>
                        } />

                        <Route path="/my-lessons" element={
                            <ProtectedRoute>
                                <StudentLessons />
                            </ProtectedRoute>
                        } />

                        <Route path="/assessments" element={
                            <ProtectedRoute>
                                <StudentAssessments />
                            </ProtectedRoute>
                        } />

                        <Route path="/my-competencies" element={
                            <ProtectedRoute>
                                <MyCompetencies />
                            </ProtectedRoute>
                        } />

                        <Route path="/my-calendar" element={
                            <ProtectedRoute>
                                <StudentCalendar />
                            </ProtectedRoute>
                        } />

                        <Route path="/my-attendance" element={
                            <ProtectedRoute>
                                <MyAttendance />
                            </ProtectedRoute>
                        } />

                        <Route path="/debug-part-a3" element={
                            <ProtectedRoute>
                                <DebugPartA3 />
                            </ProtectedRoute>
                        } />

                        <Route path="/hpc-profile" element={
                            <ProtectedRoute>
                                <HPCProfile />
                            </ProtectedRoute>
                        } />

                        <Route path="/secondary-domain-activities" element={
                            <ProtectedRoute>
                                <SecondaryDomainActivities />
                            </ProtectedRoute>
                        } />

                        <Route path="/secondary-domain-activities/:activityId" element={
                            <ProtectedRoute>
                                <DomainActivityEditor />
                            </ProtectedRoute>
                        } />

                        <Route path="/assessments/:assessmentId" element={
                            <ProtectedRoute>
                                <AssessmentDetails />
                            </ProtectedRoute>
                        } />

                        <Route path="/assessments/:assessmentId/marks-entry" element={
                            <ProtectedRoute>
                                <StudentMarksEntry />
                            </ProtectedRoute>
                        } />

                        <Route path="/assessments/:assessmentId/submission" element={
                            <ProtectedRoute>
                                <StudentMarksEntry />
                            </ProtectedRoute>
                        } />

                        <Route path="/growth-quizzes" element={
                            <ProtectedRoute>
                                <GrowthQuizPage />
                            </ProtectedRoute>
                        } />

                        <Route path="/reflections" element={
                            <ProtectedRoute>
                                <ReflectionPage />
                            </ProtectedRoute>
                        } />

                        <Route path="/growth-report" element={
                            <ProtectedRoute>
                                <GrowthReportPage />
                            </ProtectedRoute>
                        } />
                        <Route path="/official-growth-achievement" element={
                            <ProtectedRoute>
                                <OfficialGrowthAchievement />
                            </ProtectedRoute>
                        } />
                        <Route path="/official-academic-transcript" element={
                            <ProtectedRoute>
                                <OfficialAcademicTranscript />
                            </ProtectedRoute>
                        } />


                    </Routes>
                </Router>
            </AuthBootstrap>
        </ChatContextProvider>
    );
}

export default App;
